import { create } from "zustand";

type RosterFocusState = {
  hoveredColumn: string | null;
  selectedColumn: string | null;
  hoveredNurseId: string | null;
  selectedNurseId: string | null;
  setHoveredFocus: (payload: { column: string; nurseId: string }) => void;
  clearHoveredFocus: () => void;
  setSelectedFocus: (payload: { column: string; nurseId: string }) => void;
  clearSelectedFocus: () => void;
};

export const useRosterFocusStore = create<RosterFocusState>((set) => ({
  hoveredColumn: null,
  selectedColumn: null,
  hoveredNurseId: null,
  selectedNurseId: null,
  setHoveredFocus: ({ column, nurseId }) =>
    set({ hoveredColumn: column, hoveredNurseId: nurseId }),
  clearHoveredFocus: () => set({ hoveredColumn: null, hoveredNurseId: null }),
  setSelectedFocus: ({ column, nurseId }) =>
    set({ selectedColumn: column, selectedNurseId: nurseId }),
  clearSelectedFocus: () =>
    set({ selectedColumn: null, selectedNurseId: null }),
}));
